import styled from 'styled-components'
import { Link } from 'react-router-dom'

import useOrganizations from 'hooks/useOrganizations'
import useTeams from 'hooks/useTeams'

const NoEntity = ({ org }) => {
  const { organizationUuids, isAdminInAnyOrganization } = useOrganizations()
  const { teamUuids } = useTeams()
  const entities = org ? organizationUuids : teamUuids
  const noEntities = entities.isEmpty()

  // If the user is viewing a team-scoped page and is an admin in any organization, show the settings link
  const showSettingsLink = !org && isAdminInAnyOrganization

  return (
    <Card>
      <Text>
        It appears you are not currently assigned to{' '}
        {noEntities
          ? org
            ? 'an organization'
            : 'a team'
          : `this ${org ? 'organization' : 'team'}`}
        .{' '}
        {showSettingsLink ? (
          <>
            <SettingsLink to="/settings">Go to Settings</SettingsLink> to manage
            your organization.
          </>
        ) : (
          'Please contact your administrator.'
        )}
      </Text>
    </Card>
  )
}

const Card = (styled.div || styled.View)`
  padding: 48px;
`

const Text = (styled.h1 || styled.Text)`
  text-align: center;
  margin: 0;
  color: ${props => props.theme.colors.gray};
  font-size: 18px;
  font-weight: normal;
`

const SettingsLink = styled(Link)`
  color: ${props => props.theme.colors.primary || '#007bff'};
  text-decoration: underline;
  font-weight: 500;

  &:hover {
    text-decoration: none;
  }
`

export default NoEntity
